import ComponentTitle from '../../ComponentTitle/ComponentTitle'
import { Image } from '../../Image/Image'
import { Container, ImageLink } from './SpecialRef.styles'
import { usePage } from '../../../contexts'
import { addUrlParams } from '../../../utils'
import { useEffect, useState } from 'react'
import { isNativeApp } from '../../../client'
import { ISpecialRef } from '../../../types'

type Props = {
  specialRef: ISpecialRef
}

export const SpecialRef = ({
  specialRef: { link, link_for_app, target, imageObj, grid_title, grid_id },
}: Props) => {
  const page = usePage()
  const [href, setHref] = useState<string | undefined>(undefined)

  useEffect(() => {
    let forHref = isNativeApp() && link_for_app ? link_for_app : link
    if (forHref) {
      forHref = addUrlParams(forHref, [
        { key: 'refc', val: grid_id },
        { key: 'pid', val: page?.PageMeta.id + '' || '' },
      ])
    }
    setHref(forHref || '')
  }, [grid_id, link, link_for_app, page?.PageMeta.id])

  return (
    <Container>
      <ComponentTitle componentTitle={grid_title} />
      <ImageLink href={href} target={target}>
        <Image image={imageObj} alt={grid_title.text} />
      </ImageLink>
    </Container>
  )
}
